import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const bookingTypeSelectorAtom = atom<
  "GolfBooking" | "DurationBooking" | "LessonBooking" | "RequestBooking" | null
>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);
  return bookingWizardData?.type ?? null;
});
